import { createTheme } from '@mui/material';
import { color } from '@shared/constants/Styles';

import '@shared/locales/i18n';
import { createRoot } from 'react-dom/client';
import AppWithProviders from './components/AppWithProviders';

const theme = createTheme({
    palette: {
        primary: {
            main: color.tertiary,
        },
        secondary: {
            main: color.secondary,
        },
        error: {
            main: color.error,
        },
    },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}
const root = createRoot(rootElement);

root.render(<AppWithProviders />);
